export const redirectToLinkedIn = (params, endpoint) => {
    const searchParams = new URLSearchParams(params).toString();
    window.location.href = `${endpoint}?${searchParams}`;
};
//# sourceMappingURL=getLinkedInRedirectUrl.js.map